import { toast } from "react-toastify";

const baseURL = "https://riomart.store/mobile_app_api/";
function createLoader(noloader) {
    let loaderdiv = document.createElement("div");
    loaderdiv.classList.add("loaderdiv");
    let wrapper = document.createElement("div");
    wrapper.classList.add("wrapper");
    let circle = document.createElement("div");
    circle.classList.add("circle");
    let circle2 = circle.cloneNode(true);
    let circle3 = circle2.cloneNode(true);
    let shadow = document.createElement("div");
    shadow.classList.add("shadow");
    let shadow2 = shadow.cloneNode(true);
    let shadow3 = shadow2.cloneNode(true);
    let loader = document.createElement("span");
    loader.innerHTML = !noloader ? "Loading..." : "Please Wait...";
    if (!noloader) {
        shadow.appendChild(loader);
        wrapper.appendChild(circle);
        wrapper.appendChild(circle2);
        wrapper.appendChild(circle3);
        wrapper.appendChild(shadow);
        wrapper.appendChild(shadow2);
        wrapper.appendChild(shadow3);
    }
    wrapper.appendChild(loader);
    loaderdiv.appendChild(wrapper);
    return loaderdiv.innerHTML;
}
async function GetORPostAsync(url, method, data = null, headers = null, baseurlTwo = false) {
    let div = createLoader();
    let element = document.getElementById("loaderdiv");
    element.innerHTML = div;
    element.classList.add("loaderdiv");
    let validUrl = baseurlTwo ? "https://riomart.store/" : baseURL;
    let promise = new Promise((res) => {
        let xhttp2 = new XMLHttpRequest();
        xhttp2.onreadystatechange = async function () {
            if (this.readyState === 4 && this.status === 200) {
                console.log(xhttp2.responseText);
                var json = JSON.parse(xhttp2.responseText);
                res(json);
            }
        }
        xhttp2.open(method, validUrl + url, true);
        if (headers)
            xhttp2.setRequestHeader("Authorization", headers);
        if (data)
            xhttp2.send(data);
        else
            xhttp2.send();
    });
    let response = await promise;
    element.innerHTML = "";
    element.classList.remove("loaderdiv");
    return response;
}
export function copyToClipboard(str) {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    toast.success("Copied", {
        autoClose: 1000
    });
}
export default GetORPostAsync;